import { collection, addDoc, getDocs, query, where, orderBy, serverTimestamp } from 'firebase/firestore';
import { db } from '../../src/firebase.js';
import { getCampaignShareUrl } from './fundStore.js';

const LS_VIEWS = 'fg_fund_views';
const LS_CLICKS = 'fg_fund_clicks';

function readJson(key, fallback) {
    try {
        return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
    } catch {
        return fallback;
    }
}

function writeJson(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function buildUtmLinks(campaignId, campaignTitle) {
    const base = getCampaignShareUrl(campaignId);
    const slug = encodeURIComponent((campaignTitle || 'campaign').replace(/\s+/g, '-').toLowerCase());
    const mk = (source, medium) => {
        const u = new URL(base);
        u.searchParams.set('utm_source', source);
        u.searchParams.set('utm_medium', medium);
        u.searchParams.set('utm_campaign', slug);
        return `/api/track?campaign=${encodeURIComponent(campaignId)}&source=${source}&medium=${medium}&to=${encodeURIComponent(u.toString())}`;
    };
    return {
        whatsapp: mk('whatsapp', 'social'),
        instagram: mk('instagram', 'social'),
        direct: mk('direct', 'share'),
        base,
    };
}

export function recordCampaignView(campaignId) {
    if (!campaignId) return;
    const views = readJson(LS_VIEWS, {});
    views[campaignId] = (views[campaignId] || 0) + 1;
    writeJson(LS_VIEWS, views);
}

export function getCampaignViews(campaignId) {
    const views = readJson(LS_VIEWS, {});
    return views[campaignId] || 0;
}

export function getLocalClicks(campaignId) {
    const clicks = readJson(LS_CLICKS, {});
    return clicks[campaignId] || [];
}

export async function loadCampaignClicks(campaignId) {
    const local = getLocalClicks(campaignId);
    try {
        const snap = await getDocs(
            query(
                collection(db, 'fund_campaign_clicks'),
                where('campaignId', '==', campaignId),
                orderBy('createdAt', 'desc')
            )
        );
        const remote = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        return [...remote, ...local];
    } catch {
        return local;
    }
}

export function aggregateClicksBySource(clicks) {
    const map = {};
    clicks.forEach((c) => {
        const key = c.source || c.utm_source || 'unknown';
        map[key] = (map[key] || 0) + 1;
    });
    return Object.entries(map).sort((a, b) => b[1] - a[1]);
}

export function aggregateDonationsByDay(comments = []) {
    const map = {};
    comments.forEach((c) => {
        const day = (c.timestamp || '').split(',')[0] || 'Unknown';
        map[day] = (map[day] || 0) + (c.amount || 0);
    });
    return Object.entries(map);
}

export function getTopUpTotals(comments = []) {
    return (comments || []).reduce((sum, c) => sum + (Number(c.topUpAmount) || 0), 0);
}

export function getBackerFeed(project) {
    const rows = (project.comments || []).map((c) => ({
        date: c.timestamp,
        name: c.hideName ? 'Anonymous' : (c.donorName || 'Anonymous'),
        amount: c.amount || 0,
        tierAmount: c.tierAmount ?? c.amount,
        topUpAmount: c.topUpAmount || 0,
        message: c.message || '',
    }));
    return rows.sort((a, b) => (b.amount || 0) - (a.amount || 0));
}

export function renderBarChart(entries, maxBars = 6) {
    if (!entries.length) return '<p class="fg-fund-empty-sub">No data yet.</p>';
    const max = Math.max(...entries.map(([, v]) => v), 1);
    return `<div class="fg-fund-chart">${entries.slice(0, maxBars).map(([label, val]) => `
        <div class="fg-fund-chart__row">
            <span class="fg-fund-chart__label">${label}</span>
            <div class="fg-fund-chart__bar-wrap"><div class="fg-fund-chart__bar" style="width:${Math.round((val / max) * 100)}%"></div></div>
            <span class="fg-fund-chart__val">${val}</span>
        </div>`).join('')}</div>`;
}
